import Reveal from "./Reveal";

// Compact, airy hero banner for interior pages (light theme).
export default function PageHero({ eyebrow, title, subtitle, image }) {
  return (
    <section className="relative flex min-h-[58vh] items-center justify-center overflow-hidden pt-28">
      {image && (
        <>
          <img
            src={image}
            alt=""
            className="absolute inset-0 h-full w-full object-cover"
          />
          {/* Light wash so charcoal text stays readable over imagery */}
          <div className="absolute inset-0 bg-cream/70" />
          <div className="absolute inset-0 bg-gradient-to-b from-white via-white/55 to-white" />
        </>
      )}
      <div className="container-luxe relative z-10 text-center">
        <Reveal>
          {eyebrow && <p className="eyebrow mb-5">{eyebrow}</p>}
          <h1 className="section-title mx-auto max-w-4xl">{title}</h1>
          {subtitle && (
            <p className="mx-auto mt-6 max-w-2xl font-sans text-base font-light leading-relaxed text-charcoal/65">
              {subtitle}
            </p>
          )}
          <div className="mx-auto mt-8 hairline" />
        </Reveal>
      </div>
    </section>
  );
}
